import api from '../../api'

import {
    SET_ALL_REALESTATE_APPRAISALS,
    SET_REALESTATE_APPRAISALS
} from '../../constants'

const default_state = {
    all_appraisals: {},
    appraisals: {}
}
const state = default_state

const actions = {
    FETCH_ALL_REALESTATE_APPRAISALS: ({state, commit, rootState}, data) => {

        // console.log('data.path (fetch_realestate_appraisals) ---->')
        // console.log(data.path)

        let temp_all_appraisals = []

        return api.get({path: data.path})
            .then((res) => {
                console.log(res)
                commit(SET_ALL_REALESTATE_APPRAISALS, res.all_children)
            })
    },
    FETCH_REALESTATE_APPRAISALS: ({state, commit, rootState}, data) => {

        // console.log('data.path (fetch_realestate_appraisals) ---->')
        // console.log(data.path)
        return api.get({path: data.path})
            .then((res) => {
                console.log(res)
                commit(SET_REALESTATE_APPRAISALS, res)
            })
    }
}

const mutations = {
    [SET_ALL_REALESTATE_APPRAISALS] (state, data) {
        state.appraisals = check_undefined(data)
    },
    [SET_REALESTATE_APPRAISALS] (state, data) {
        state.appraisals = check_undefined(data)
    }
}

const getters = {
    all_realestate_appraisals: state => {
        return state.all_appraisals
    },
    realestate_appraisals: state => {
        return state.appraisals
    }
}


function check_undefined (myVar) {
    if (typeof myVar !== 'undefined') {
        return myVar
    } else {
        return null
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/realestate/realestate_appraisals.js